import { configureStore } from "@reduxjs/toolkit";
// import sidebarSlice from "./sidebarSlice";
import activeAreasSlice from "./activeAreasSlice";
import systemSlice from "./systemSlice";
import myAppsSlice from "./myAppsSlice";
import themeSlice from "./themeSlice";
import eventListenerSlice from "./eventListenerSlice";
import myUserSlice from "./myUserSlice";
const store = configureStore({
    reducer: {
        // sideBar: sidebarSlice.reducer,
        activeAreas: activeAreasSlice.reducer,
        systemSlice: systemSlice.reducer,
        myAppsSlice: myAppsSlice.reducer,
        themeSlice: themeSlice.reducer,
        eventListenerSlice: eventListenerSlice.reducer,
        myUserSlice: myUserSlice.reducer

    }
})

export default store